<template>
  <Menu v-if="user" as="div">
    <div class="pt-4 pb-3 border-t border-gray-900">
      <MenuButton class="dropdown-icon">
        <span class="sr-only">
          Menü öffnen
        </span>
        <div class="flex items-center px-4 pl-6 cursor-pointer">
          <div class="flex-shrink-0">
            <span class="inline-block h-8 w-8 rounded-full overflow-hidden bg-gray-100">
              <div v-if="user.image">
                <img :src="user.image.image_uri" :alt="user.name" />
              </div>
              <div v-else="user.image">
                <ProfileIconSvg  />
              </div>
            </span>
          </div>
          <div class="ml-3 text-left">
            <div class="text-base font-medium leading-none text-white">
              {{ user.name }}
            </div>
            <div class="text-sm font-medium leading-none text-gray-400">
              {{ user.email }}
            </div>
          </div>
        </div>
      </MenuButton>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems class="dropdown-items">
        <MenuItem v-slot="{ active }">
          <router-link :to="profile" class="dropdown-item" role="menuitem">
            Profil
          </router-link>
        </MenuItem>
        <MenuItem v-slot="{ active }">
          <router-link :to="{name: 'feedback'}" class="dropdown-item" role="menuitem">
            Feedback geben
          </router-link>
        </MenuItem>
        <hr class="border-t border-gray-900" />
        <MenuItem v-slot="{ active }">
          <router-link :to="{name: 'settings'}" class="dropdown-item" role="menuitem">
            Einstellungen
          </router-link>
        </MenuItem>
        <MenuItem v-if="nova" v-slot="{ active }">
          <a href="/nova" target="_blank" class="dropdown-item" role="menuitem">
            Administration
          </a>
        </MenuItem>
        <hr class="border-t border-gray-900" />
        <MenuItem v-slot="{ active }">
          <a @click="onLogout" class="dropdown-item " role="menuitem">
            Logout
          </a>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const user = computed(() => store.getters["auth/user"]);
const nova = computed(() => store.getters["auth/nova"]);
const profile = computed(() => ({name: 'profile', params: {id: store.getters["auth/user"].id}}));

const onSuccess = () => {
  console.log("Logout successful");
  router.push({ name: "login" });
};

const onFailure = () => {
  console.log("Logout failed");
  router.push({ name: "login" });
};

const onLogout = () => {
  store.dispatch('auth/logout')
    .then(result => onSuccess(result))
    .catch(error => onFailure(error));
};
</script>

<style scoped>
.dropdown-item
{
  @apply block px-3 py-2;
  @apply text-base font-medium text-gray-400;
  @apply rounded-md;
  @apply hover:text-white hover:bg-gray-900;
  @apply cursor-pointer;
}

.dropdown-items
{
  @apply px-2;
}

</style>
